module.exports = __webpack_public_path__ + "static/media/TabulaRx.34d7cb41.png";